/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pm_Missing_CredentialsInputs */

const cs_pm_missing_credentials = /** @type {(inputs: Pm_Missing_CredentialsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chybí přihlašovací údaje k API`)
};

const en_pm_missing_credentials = /** @type {(inputs: Pm_Missing_CredentialsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API credentials missing`)
};

/**
* | output |
* | --- |
* | "API credentials missing" |
*
* @param {Pm_Missing_CredentialsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pm_missing_credentials = /** @type {((inputs?: Pm_Missing_CredentialsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pm_Missing_CredentialsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pm_missing_credentials(inputs)
	return cs_pm_missing_credentials(inputs)
});